module.exports = __webpack_public_path__ + "static/media/spec_careplan.775d5225.png";